import { CheckStatus, MonitorStatus } from "@oneleet/api_client";
import { cn, getReadableText } from "@oneleet/utils";

import { VariantProps, cva } from "class-variance-authority";

const statusIndicatorVariants = cva("size-4 shrink-0", {
  variants: {
    checkStatus: {
      [CheckStatus.FAILING]: "stroke-ng-red-900 fill-ng-red-800",
      [CheckStatus.NEEDS_CHANGES]: "stroke-ng-orange-900 fill-ng-orange-400",
      [CheckStatus.PASSING]: "stroke-ng-green-900 fill-ng-green-800",
      [CheckStatus.IN_PROGRESS]: "stroke-accent-800 fill-accent-400",
      [CheckStatus.PENDING]: "fill-accent-400 stroke-accent-800",
      [CheckStatus.INACTIVE]: "fill-neutral-50 stroke-neutral-400",
    },
    monitorStatus: {
      [MonitorStatus.BREACHING_SLA]: "stroke-ng-red-900 fill-ng-red-800",
      [MonitorStatus.ALERTING]: "stroke-ng-orange-900 fill-ng-orange-800",
      [MonitorStatus.PASSING]: "stroke-ng-green-900 fill-ng-green-800",
      [MonitorStatus.NO_APPLICABLE_ASSETS]:
        "fill-neutral-50 stroke-neutral-400",
      [MonitorStatus.NOT_YET_RUN]: "fill-accent-400 stroke-accent-800",
      [MonitorStatus.IGNORED]: "stroke-neutral-450 fill-neutral-300",
      [MonitorStatus.DISABLED]: "stroke-neutral-450 fill-neutral-300",
    },
  },
});

export type MonitorStatusIndicatorProps = VariantProps<
  typeof statusIndicatorVariants
> & {
  className?: string;
};

export const MonitorStatusIndicator = ({
  monitorStatus,
  checkStatus,
  className,
}: MonitorStatusIndicatorProps) => {
  if (!monitorStatus && !checkStatus)
    throw new Error(
      "No status prop was passed to MonitorStatusIndicator but is required",
    );

  return (
    <svg
      viewBox="0 0 16 16"
      className={cn(
        statusIndicatorVariants({ monitorStatus, checkStatus }),
        className,
      )}
      aria-label={getReadableText(
        monitorStatus ?? checkStatus ?? "unknown status",
      )}
    >
      <rect
        x="3.7"
        y="3.7"
        width="8.6"
        height="8.6"
        rx="4.3"
        strokeWidth="1.4"
      />
    </svg>
  );
};
